"use client"

import { toImageSrc } from "@/lib/utils"
import Image from "next/image"
import { twMerge } from "tailwind-merge"
import type { SupplierGridItem } from "../types"
import "./styles.css"

interface SupplierGridContentProps {
  items: SupplierGridItem[]
  className?: string
}

const SupplierGridContent = ({ items, className }: SupplierGridContentProps) => {
  return (
    <section className={twMerge("tamda-supplier-grid", className)}>
      <div className="tamda-supplier-grid__list">
        {items.map((item, index) => (
          <article className="tamda-supplier-card" key={index}>
            <div className="tamda-supplier-card__media">
              <Image
                src={toImageSrc(item.image)}
                alt={item.title || "supplier"}
                fill
                sizes="(max-width: 1023px) 100vw, 22vw"
                loading="lazy"
              />
            </div>

            <div className="tamda-supplier-card__body">
              {item.title ? <h2 className="tamda-supplier-card__title">{item.title}</h2> : null}

              {item.description ? (
                <div
                  className="tamda-supplier-card__desc"
                  dangerouslySetInnerHTML={{ __html: item.description }}
                />
              ) : null}

              {item.contact ? (
                <div
                  className="tamda-supplier-card__contact"
                  dangerouslySetInnerHTML={{ __html: item.contact }}
                />
              ) : null}
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}

export default SupplierGridContent
